<template>
  <div class="hero">
    <div class="coverImageWrap">
      <agile ref="heroAgile" class="hidden md:block" :options="sliderOptions" v-if="!isMobile">
        <template v-for="(img, index) in meta.images">
          <div :key="img + index" class="relative image-container-fix" :class="img.url && 'cursor-pointer'" @click="clickHero(img)">
            <img :src="`${img.imageURL}?format=webp&quality=50`" :alt="`cover_${index}`" :ref="`cover_${index}`" class="image-block block w-full" style="object-fit: cover; object-position: center; width: 100%;" :fetchpriority="isMobile ? 'low' : 'high'" :loading="isMobile ? 'lazy' : 'eager'">
            <div class="absolute select-none" style="top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(transparent, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .35) 100%);">
              <!-- <img class="absolute" style="bottom:0; left:0; width: 100%; height: 100%;" :src="coverLine" alt="coverLine">
              <div class="absolute" style="top:calc(50% - 3vw); left: 8vw; min-width: 15vw;">
                <div class="relative w-full" style="margin-left: 32px;">
                  <img :src="coverHouse" alt="coverHouse" class="inline-block ml-48 svgShadow" style="width: calc(20px + 15vw);">
                  <div class="absolute text-white font-bold text-shadow" style="top: 3vw; left: 1vw;">
                    <div class="heroTitleShadow font-bold" style="font-size: calc(8px + 2vw); letter-spacing: normal;">{{ $t('hero.mainTitle') }}</div>
                    <div class="heroTitleShadow font-bold" style="font-size: calc(8px + 1.3vw); letter-spacing: normal;">{{ $t('hero.subTitle') }}</div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </template>
        <template slot="prevButton">
          <i class="owl-direction-left"></i>
        </template>
        <template slot="nextButton">
          <i class="owl-direction-right"></i>
        </template>
      </agile>
      <section class="kv-hero mobile-image relative block md:hidden image-block bg-cover bg-center" style="object-fit: cover; object-position: center; height: 200px;">
        <!-- <div class="mobile-image relative"> -->
          <!-- <img class="image-block block w-full" width="390" height="200" style="object-fit: cover; object-position: center; width: 100%;" v-lazy="require('@/assets/images/mobile_bg.webp')" alt=""> -->
        <div class="absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); min-width: 15vw;">
          <div class="relative w-full">
            <img :src="coverHouse" alt="coverHouse" width="100" height="55" class="inline-block ml-16 svgShadow" style="width: calc(40px + 15vw);">
            <div class="absolute text-white font-bold text-shadow" style="top: 4.5vw; left: 1vw;">
              <div class="heroTitleShadow font-bold" style="font-size: calc(8px + 2vw); letter-spacing: normal;">{{ $t('hero.mainTitle') }}</div>
              <div class="heroTitleShadow font-bold" style="font-size: calc(8px + 1.3vw); letter-spacing: normal;">{{ $t('hero.subTitle') }}</div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </section>
      <div class="hero__mask m-16 mb-0 relative lg:m-0">
        <transition name="fade">
          <div v-if="isMask" class="searchMask"></div>
        </transition>
        <div class="hero__search container" v-click-outside="clickOutsideConfig" v-focus-outside="blurHandler">
          <div class="hero__search__left">
            <searchPlaceInput ref="searchPlaceInput" style="min-width: 300px;" forceDesktop/>
            <searchDatePicker ref="searchDatePicker" style="min-width: 300px;" :isBlock="isTablet" forceDesktop/>
            <searchPeoplePicker ref="searchPeoplePicker" style="min-width: 220px;" forceDesktop/>
          </div>
          <button class="btn btn-solid btn-blue-light py-12 rounded-full focus:bg-blue" style="min-width: 110px;" @click.stop="submitSearchData">{{ $t('search') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import owlsight from 'owlsight/src/tailwind.js'

import coverLine from '@/assets/images/hero-lines.svg'
import coverHouse from '@/assets/images/hero-house.svg'

import searchActions from '@/mixins/searchActions'

export default {
  name: 'hero',
  components: {
  },
  props: ['meta'],
  metaInfo () {
    return {
      // link: this.heroPreload
    }
  },
  data () {
    return {
      parallaxElement: null,
      owlsight: owlsight,
      coverLine,
      coverHouse,
      isMask: false,
      clickOutsideConfig: {
        handler: this.clickOutsideHandler,
        middleware: this.clickOutsideMiddleware
      }
    }
  },
  mixins: [
    searchActions
  ],
  computed: {
    ...mapGetters([
      'isMobile',
      'isTablet',
      'initWidth',
      'windowWidth',
    ]),
    sliderOptions: function () {
      return {
        timing: 'ease',
        speed: 800,
        autoplaySpeed: 5000,
        dots: this.meta.images.length > 1,
        fade: true,
        autoplay: true,
        pauseOnHover: false,
        navButtons: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              autoplaySpeed: 5000
            }
          }
        ]
      }
    },
    autoComplete: function () {
      return this['search/autoComplete']
    },
    heroImageHeight: function () {
      if (this.initWidth >= 1200) {
        return 400 * 1.2
      } else if (this.initWidth < 1200 && this.initWidth >= 768) {
        return 300 * 1.2
      } else {
        return 200 * 1.2
      }
    },
    heroPreload: function () {
      return this.meta?.images?.reduce((acc, curr) => {
        acc.push({
          rel: 'preload',
          as: 'image',
          href: curr.imageURL + '?format=webp'
        })

        return acc
      }, [])
    }
  },
  methods: {
    clickOutsideMiddleware: function (event) {
      console.debug('Middleware', event)
      return true
    },
    clickOutsideHandler: function (event) {
      if (!this.clickOutsideMiddleware()) return
      console.debug('clickOutsideHandler', this.clickOutsideMiddleware(), event.target.classList)
      this.blurHandler()
    },
    blurHandler: function () {
      this.isMask = false
    },
    submitSearchData: async function () {
      let form = {}
      let errors = []
      await this.validateSearchPlaceInput().then(res => {
        form.search = res
      }).catch(err => {
        errors.push('searchPlaceInput')
        console.error(err)
        this.isMask = true
        throw Error('searchPlaceInput is not filled.')
      })
      await this.validateSearchDatePicker().then(res => {
        form.date = res
      }).catch(err => {
        errors.push('searchDatePicker')
        console.error(err)
        this.isMask = true
        throw Error('searchDatePicker is not filled.')
      })
      await this.validateSearchPeoplePicker().then(res => {
        form.people = res
      }).catch(err => {
        errors.push('searchPeoplePicker')
        console.error(err)
        this.isMask = true
        throw Error('searchPeoplePicker is not filled.')
      })
      // If all validations passed
      if (errors.length > 0) {
        const errMsg = []
        for (const err of errors) {
          errMsg.push(this.$t(err))
        }
        // this.$modal.show(searchWarningModal, {
        //   context: `請完整輸入${errMsg.join(this.$t('and'))}`
        // }, {
        //   width: 380,
        //   height: 200
        // })
      } else {
        this._onClickSearchButton(form)
      }
    },
    validateSearchPlaceInput: function () {
      return this.$refs.searchPlaceInput.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    validateSearchDatePicker: function () {
      return this.$refs.searchDatePicker.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    validateSearchPeoplePicker: function () {
      return this.$refs.searchPeoplePicker.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    clickIntercept: function ($event) {
      if (this.isMobile) {
        $event.stopPropagation()
        this.$searchMobileModal.toggle()
      }
    },
    clickHero: function (img) {
      if (img.url) {
        window.open(img.url)
      }
      window.dataLayer.push({
        event: 'index_hero',
        key: img.loc
      })
    },
    parallaxHandler: function () {
      const scrolledHeight = window.pageYOffset
      const limit = this.parallaxElement.offsetTop + this.parallaxElement.offsetHeight
      if (scrolledHeight > this.parallaxElement.offsetTop && scrolledHeight <= limit) {
        this.parallaxElement.style.backgroundPositionY = (scrolledHeight - this.parallaxElement.offsetTop) / 1.5 + 'px'
      } else {
        this.parallaxElement.style.backgroundPositionY = '0'
      }
    }
  },
  created () {
    // this.selected.location = this['search/filters'].location
  },
  mounted () {
    this.parallaxElement = document.querySelector('.kv-hero')
    window.addEventListener('scroll', this.parallaxHandler)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.parallaxHandler)
  },
  watch: {
    windowWidth: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          if (this.$refs.heroAgile) {
            this.$refs.heroAgile.reload()
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.hero
  @apply flex flex-wrap relative
  @screen lg
    @apply mb-72
  .coverImageWrap
    @apply w-full
    .swiper-slide
      padding-top: imageRatio(1441, 476)
      @apply bg-center bg-cover bg-grey-lighter
  &__mask
    z-index: 9
  &__search
    @apply flex flex-col items-center justify-between
    @apply relative shadow-lg z-10
    @apply bg-white border border-grey-lighter p-16
    transform: translateY(-30px)
    border-radius: 1.25rem
    @screen lg
      @apply flex-row justify-between px-16 py-4
      @apply absolute
      bottom: 0
      left: 50%
      transform: translateX(-50%) translateY(50%)
      max-width: 966px
    &__left
      @apply flex items-center flex-col
      @apply w-full
      @screen lg
        @apply flex-row justify-between
        @apply w-auto
      & > div
        & > div, & > div > div
          @apply cursor-pointer
          box-shadow: none !important
        @apply mx-8 mb-16
        @apply w-full
        @screen lg
          @apply mx-0 mb-0
    & > div, & button
      @apply w-full
      @screen lg
        @apply w-auto
  .agile__slides.agile__slides--regular
    // @apply flex-no-grow
  .agile__slide
    // @apply hidden
    &.agile__slide--active
      // @apply block
    // &.agile__slide--current
  .heroTitleShadow
    @apply whitespace-no-wrap
    text-shadow: 3px 2px 3px rgba(#333, .8)
  .svgShadow
    -webkit-filter: drop-shadow(3px 2px 3px rgba(#333, .8))
    filter: drop-shadow(3px 2px 3px rgba(#333, .8))
  .errorMsg
    @apply text-xs text-red mt-4
.searchMask
  @apply pin-t pin-l p-0 m-0
  @apply fixed
  background-color: black
  background-color: rgba(0, 0, 0, .4)
  width: calc(100vw - (100vw - 100%))
  height: 100vh
  z-index: 10
.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to, .fade-leave-active
  opacity: 0
.image-container-fix, .image-block
  background-image: url('../assets/images/mobile_bg.webp')
  height: 200px
  @screen md
    height: 300px
  @screen xl
    height: 400px
//   min-height: 140px
//   @screen lg
//     min-height: 320px
//     max-height: 320px
//   @screen xl
//     max-height: 400px
//   @media (min-width: 1441px)
//     max-height: 500px
</style>
